import React from 'react';
import {  FaNewspaper, FaPhoneAlt, FaComments, FaRocket, FaInfoCircle, FaTachometerAlt } from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = ({ className, onSelectComponent, activeComponent }) => {
  return (
    <div className={`sidebar ${className}`}>
      <ul className="sidebarList">
        <li 
          className={`sidebarItem ${activeComponent === "MainDashboard" ? 'activedd' : ''}`} 
          onClick={() => onSelectComponent("MainDashboard")}
        >
          <FaTachometerAlt className="sidebarIcon" /> Dashboard
        </li>
        <li 
          className={`sidebarItem ${activeComponent === "AddNews" ? 'activedd' : ''}`} 
          onClick={() => onSelectComponent("AddNews")}
        >
          <FaNewspaper className="sidebarIcon" /> News
        </li>
        <li 
          className={`sidebarItem ${activeComponent === "AddEvents" ? 'activedd' : ''}`} 
          onClick={() => onSelectComponent("AddEvents")}
        >
          <FaNewspaper className="sidebarIcon" /> Add Event
        </li>
        <li 
          className={`sidebarItem ${activeComponent === "Contact" ? 'activedd' : ''}`} 
          onClick={() => onSelectComponent("Contact")}
        >
          <FaPhoneAlt className="sidebarIcon" /> Contact
        </li>
        <li 
          className={`sidebarItem ${activeComponent === "Comments" ? 'activedd' : ''}`} 
          onClick={() => onSelectComponent("Comments")}
        >
          <FaComments className="sidebarIcon" /> Comments
        </li>
        <li 
          className={`sidebarItem ${activeComponent === "TouristAttraction" ? 'activedd' : ''}`} 
          onClick={() => onSelectComponent("TouristAttraction")}
        >
          <FaComments className="sidebarIcon" /> Tourist Attraction
        </li>
        <li 
          className={`sidebarItem ${activeComponent === "AgenesisApproval" ? 'activedd' : ''}`} 
          onClick={() => onSelectComponent("AgenesisApproval")}
        >
          <FaRocket className="sidebarIcon" /> Agenesis
        </li>
        <li 
          className={`sidebarItem ${activeComponent === "TouristInfoCenter" ? 'activedd' : ''}`} 
          onClick={() => onSelectComponent("TouristInfoCenter")}
        >
          <FaInfoCircle className="sidebarIcon" /> Add Information Center
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
